import React from 'react';
import PropTypes from 'prop-types';

export default function ErrorMessage({ text, testid }) {
  return <p className="notification is-danger" data-testid={testid}>{text}</p>;
}
ErrorMessage.defaultProps = {
  testid: '',
};
ErrorMessage.propTypes = {
  text: PropTypes.string.isRequired,
  testid: PropTypes.string,
};
